import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../pages/Home.vue'

import { authDisabled, routerProtector } from './router.protector'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/apiTest',
    name: 'echo',
    component: () => import('../pages/EchoApi.vue')
  },
  {
    path: '/login',
    name: 'login',
    //beforeEnter: authDisabled,
    component: () => import('../pages/Login.vue')
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('../pages/Dashboard')
  },
  {
    path: '/profile',
    name: 'profile',
    // beforeEnter: routerProtector(['profiles']),
    component: () => import('../pages/Dashboard/Profile.vue')
  },
  {
    path: '*',
    redirect: '/'
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
